export const createBaseSelectors = (pathToSlice = '') => {
    const getSlice = (state) => pathToSlice
        .split('.')
        .filter(Boolean)
        .reduce((currentSlice, pathSegment) => (currentSlice !== null && currentSlice !== void 0 ? currentSlice : {})[pathSegment], state);
    const getIsLoading = (state) => { var _a; return (_a = getSlice(state)) === null || _a === void 0 ? void 0 : _a.isLoading; };
    const getLastError = (state) => { var _a; return (_a = getSlice(state)) === null || _a === void 0 ? void 0 : _a.lastError; };
    const getLastSuccess = (state) => { var _a; return (_a = getSlice(state)) === null || _a === void 0 ? void 0 : _a.lastSuccess; };
    const getData = (state) => { var _a; return (_a = getSlice(state)) === null || _a === void 0 ? void 0 : _a.data; };
    const getError = (state) => { var _a; return (_a = getSlice(state)) === null || _a === void 0 ? void 0 : _a.error; };
    const getHasAFetchFinished = (state) => !!(getLastSuccess(state) || getLastError(state));
    const getHasLoadedSuccessfully = (state) => !!getLastSuccess(state);
    return {
        getSlice,
        getIsLoading,
        getLastError,
        getLastSuccess,
        getData,
        getError,
        getHasAFetchFinished,
        getHasLoadedSuccessfully,
    };
};
//# sourceMappingURL=create-base-selectors.js.map